import React from 'react';

import Banner from '../../components/Banner';
import ArticleSpreader from '../../components/ArticleSpreader';
import Paragraph from '../../components/Paragraph';
import ParagraphWithImage from '../../components/ParagraphWithImage';
import Accentuation from '../../components/Accentuation';
import Fact from '../../components/Fact';
import Quote from '../../components/Quote';
import RightBanner from '../../components/RightBanner';
import Slider from '../../components/Slider';
import Roles from '../../components/Roles';
import LeftBanner from '../../components/LeftBanner';
import Article from '../../components/Article';
import EndSpreader from '../../components/EndSpreader';
import MoreArticles from '../../components/MoreArticles';
import BarChart from '../../components/BarChart';

import { Helmet } from 'react-helmet';

const InterviewPage = props => (
  <div>
    <Helmet>
      <title>«Наш внутренний девиз — у нас всегда есть решение» - Специальный проект Alfa Private</title>
    </Helmet>
    <Article
      banner={
        <Banner
          title="«Наш внутренний девиз — у нас всегда есть решение»"
          backgroundImage="images/banners/bg.jpg"
        />
      }
      location={props.location}
      showSocialSharing
    >
      {[
        {
          body: (
            <div>
              <ArticleSpreader>
                <Paragraph>
                  <img src="images/media/zahod4_1.jpg" width="100%" />
                </Paragraph>
                <Paragraph>
                  О том, как геополитика отражается на бизнесе Private Banking,
                  возвращении капитала в Россию, продуктах и сервисах, которые
                  доступны высокосостоятельным клиентам, а также преимуществах
                  российского банка в решении инвестиционных и цифровых задач,
                  рассказала управляющий директор Альфа Private Катерина
                  Милеева.
                </Paragraph>
                <Paragraph>
                  <b>
                    Нынешняя конъюнктура с постоянно расширяющимися санкциями
                    против России отражается на состоянии экономики и банковской
                    отрасли. Как в таких условиях чувствует себя отрасль Private
                    Banking?
                  </b>
                </Paragraph>
                <Paragraph>
                  Мы&nbsp;не&nbsp;видим резких движений со&nbsp;стороны клиентов
                  из-за санкционного фактора: закрытия счетов, распродажи
                  активов, массового вывода средств&nbsp;&mdash; этого нет. Да,
                  это тема, которая всех волнует, и, конечно, клиенты задают нам
                  вопросы: каковы возможные риски, последствия для активов,
                  расчетов и т. д.{' '}
                  <Accentuation>
                    <a href="https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article4&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article4" target="_blank">
                      Наша позиция&nbsp;&mdash; поддерживать открытый диалог.
                    </a>
                  </Accentuation>
                  &nbsp;Мы&nbsp;провели несколько бизнес-завтраков
                  по&nbsp;проблематике санкций, это уже почти регулярная
                  история&nbsp;&mdash; с&nbsp;привлечением юридических
                  партнеров, аналитиков, комплаенса: чтобы наши клиенты могли
                  задать вопросы, которые их&nbsp;тревожат. Все понимают, что
                  реальность в&nbsp;условиях санкций надолго, и&nbsp;стараются
                  адаптироваться к&nbsp;ней, а&nbsp;наша задача&nbsp;&mdash;
                  помочь и&nbsp;поддержать: экспертизой, аналитикой, готовностью
                  к&nbsp;общению по&nbsp;этим вопросам.
                </Paragraph>
                <Paragraph>
                  <b>
                    В последнем исследовании Frank RG отмечает приток инвестиций
                    из-за рубежа в Россию, но темпы символические. Всего 5%
                    прироста отрасли в этом году дала репатриация капитала.
                    Ощущаете на своем бизнесе эти тренды? Почему перетоки не
                    идут более высокими темпами?
                  </b>
                </Paragraph>
                <Paragraph>
                  На самом деле, волна возврата капитала наблюдалась и в этом
                  году, и в прошлом. Скромный эффект на годовом горизонте может
                  быть обусловлен тенденцией, которую мы видим: клиенты,
                  возвращающие активы в рамках амнистии капитала, не задаются
                  целью оставить их в России. Очень часто, воспользовавшись
                  возможностью легализовать капитал, они{' '}
                  <Accentuation>
                    размещают активы в зарубежных финансовых институтах,
                  </Accentuation>{' '}
                  но уже соблюдая все требования законодательства, касающиеся
                  правил декларирования и структуры владения. Причины разные,
                  чаще всего мы слышим о страновых рисках и особенностях
                  регуляторной среды: трасты и КИКи остаются предпочтительной
                  формой владения{' '}
                  <Accentuation>
                    и управления глобальными инвестициями для самого высокого
                    сегмента клиентов.
                  </Accentuation>
                </Paragraph>

                <Fact source="Катерина Милеева">
                  «Мы единственные на рынке, кто предлагает частным клиентам
                  услугу полноценной инкассации»
                </Fact>
                <Paragraph>
                  <b>Насколько сложен процесс возврата капитала?</b>
                </Paragraph>
                <Paragraph>
                  Это очень частный вопрос, все зависит от конкретного кейса. В
                  среднем, если говорить, например, о ликвидации КИКа, то
                  принятие решения о ликвидации, перевод активов и подача
                  декларации занимают около трех месяцев, перевод средств в
                  рамках амнистии можно осуществить меньше чем за месяц. У нас
                  отличные партнеры в области налогового и юридического
                  консалтинга, мы помогаем клиентам: это не простой операционный
                  процесс, но при этом вполне реалистичный.
                </Paragraph>
              </ArticleSpreader>

              <Paragraph>
                <RightBanner image="images/media/4banner12.jpg">
                  Клиенты говорят нам о том, что они чувствуют разницу с первого
                  дня работы с нами
                </RightBanner>
              </Paragraph>

              <ArticleSpreader>
                <Paragraph>
                  <b>
                    Есть мнение, что клиенты с опытом сотрудничества с западными
                    банками, возвращаясь в Россию, придерживаются более
                    агрессивной стратегии инвестирования. Действительно
                    возвращается только инвестиционная часть их сбережений,
                    тогда как депозиты они продолжают держать в швейцарских
                    банках? С чем это может быть связано?
                  </b>
                </Paragraph>
                <Paragraph>
                  Это может быть обусловлено тем, что часто клиенты
                  рассматривают счет в&nbsp;зарубежном банке как &laquo;кубышку
                  на&nbsp;черный день&raquo;&nbsp;&mdash; надежное место
                  хранения активов с&nbsp;более низкими, в&nbsp;частности
                  становыми, рисками. Соответственно, размещают там самую
                  консервативную часть капитала, несмотря на&nbsp;более низкие
                  ставки по&nbsp;депозитам&nbsp;&mdash; эти деньги решают другую
                  задачу, вопросы доходности и&nbsp;инвестиционных стратегий
                  становятся вторичными.
                </Paragraph>
                <Paragraph>
                  Активы на&nbsp;российских счетах размещаются в&nbsp;том числе
                  в&nbsp;инвестиционные инструменты и&nbsp;стратегии, поскольку
                  задача другая&nbsp;&mdash; как минимум сохранить покупательную
                  способность этих денег.
                </Paragraph>
                <Paragraph>
                  <b>
                    Отличается ли работа с клиентами, которые обслуживались
                    ранее в западном банке, и теми, которые такого опыта не
                    имеют?
                  </b>
                </Paragraph>
                <Paragraph>
                  Может показаться неожиданным, но с клиентами, которые
                  сотрудничали с западными банками, нам проще и интереснее
                  работать. Им есть с чем сравнивать, и поэтому они лучше
                  понимают ценность наших продуктовых решений, качества сервиса,
                  внимательного отношения к ним и их сбережениям.
                </Paragraph>
                <Paragraph>
                  На&nbsp;Западе уровень сервиса для клиентов с&nbsp;активами
                  от&nbsp;$100&nbsp;млн и&nbsp;до&nbsp;$10&nbsp;млн значительно
                  отличаются. Для многих глобальных банковских домов,
                  у&nbsp;которых под управлением находятся миллиарды долларов,
                  отношения с&nbsp;клиентами с&nbsp;капиталом от&nbsp;1
                  до&nbsp;25&nbsp;млн&nbsp;долларов зачастую
                  не&nbsp;представляют значимого бизнес-интереса. Наша честная
                  позиция такая:{' '}
                  <Accentuation>
                    если посмотреть на&nbsp;потребности самых состоятельных
                    клиентов в&nbsp;сегменте с&nbsp;активами свыше
                    $100&nbsp;млн&nbsp;долларов, наша инфраструктура проигрывает
                    возможностям глобальных банков, но&nbsp;при этом у&nbsp;нас
                    действительно очень высокие стандарты сервиса
                    и&nbsp;экспертизы&nbsp;&mdash; как классической банковской,
                    так и&nbsp;инвестиционной.
                  </Accentuation>{' '}
                  Для нас каждый клиент важен, и, например, с&nbsp;точки зрения
                  дейли-банкинга и&nbsp;организации &laquo;онлайн фэмили
                  офиса&raquo; мы&nbsp;однозначно можем дать более качественный
                  сервис; у&nbsp;нас отличные цифровые приложения&nbsp;&mdash;
                  клиенты говорят нам о&nbsp;том, что они чувствуют разницу
                  с&nbsp;первого дня работы с&nbsp;нами.
                </Paragraph>
                <Paragraph>
                  <img src="images/media/mileeva_inner12.jpg" width="100%" />
                </Paragraph>
                <Paragraph>
                  <b>Сколько сейчас клиентов и их семей обслуживается у вас?</b>
                </Paragraph>
                <Paragraph>
                  Мы&nbsp;обслуживаем свыше 4 тысяч семей. Семейное
                  обслуживание&nbsp;&mdash; важная часть нашей стратегии.
                  Мы&nbsp;понимаем, что основная забота клиента&nbsp;&mdash; это
                  забота о&nbsp;его близких. Мы&nbsp;развиваем множество
                  сервисов, направленных именно на&nbsp;семейное обслуживание,
                  чтобы всем членам семьи было комфортно
                  с&nbsp;Альфа-Банком. В&nbsp;нашем мобильном
                  приложении можно управлять счетами индивидуально, а&nbsp;можно
                  сделать доступ для семьи или доверенных лиц с&nbsp;тонко
                  настроенными лимитами. Мы&nbsp;предлагаем много продуктовых
                  сервисных программ, проводим сегментированное обучение,
                  стараясь решить задачи каждого члена семьи или близких людей
                  бенефициара.
                </Paragraph>
                <Paragraph>
                  <b>
                    Какие новые продукты {' '}
                      <a href="https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article4&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article4" target="_blank">
                        Альфа-Банк 
                      </a>
                      {' '}
                      предлагает
                    высокосостоятельным клиентам?
                  </b>
                </Paragraph>
                <Paragraph>
                  В&nbsp;этом году мы&nbsp;запустили очень много новых сервисных
                  решений: мы&nbsp;единственные на&nbsp;рынке, кто предлагает
                  частным клиентам услугу полноценной инкассации&nbsp;&mdash;
                  мы&nbsp;можем забрать или доставить деньги клиенту
                  в&nbsp;удобное для него время и&nbsp;место без необходимости
                  для него лично передвигаться в&nbsp;инкассаторской машине.
                  Существенно улучшили мобильное приложение: теперь наши клиенты
                  могут без визита в&nbsp;офис конвертировать валюту
                  по&nbsp;специальному курсу, выпустить и&nbsp;активировать
                  карту, присвоить пин и&nbsp;начать ей&nbsp;пользоваться.
                  Мы&nbsp;разработали 
                  {' '}
                  <Accentuation>
                       функционал удаленного подтверждения
                    большей части банковских операций через приложение
                    и&nbsp;сделали этот сервис доступным не&nbsp;только для
                    клиентов, но&nbsp;и&nbsp;для их&nbsp;доверенных лиц,
                    а&nbsp;также предложили клиентам услуги VR-консультанта.
                  </Accentuation>{' '}

                  Мы&nbsp;активно развиваем кредитование&nbsp;&mdash;
                  мы&nbsp;наблюдаем устойчивый спрос на&nbsp;различные
                  инструменты финансирования и&nbsp;готовы работать
                  с&nbsp;клиентами в&nbsp;рамках индивидуальных кейсов.
                  Рассматриваем практически любые залоги: от&nbsp;жилой
                  и&nbsp;коммерческой недвижимости до&nbsp;депозита или портфеля
                  ценных бумаг.&nbsp;При этом мы&nbsp;продолжаем развивать
                  классическую линейку банковских продуктов, находим новые
                  интересные решения даже для стандартных депозитов
                  и&nbsp;накопительных счетов.
                </Paragraph>
                <Paragraph>
                  <b>Насколько вырос спрос на инвестиционные продукты?</b>
                </Paragraph>

                <Paragraph>
                  Я&nbsp;не&nbsp;раскрою секрета, если скажу, что этот
                  год&nbsp;&mdash; непростой для финансовых рынков. Большая
                  часть активов по&nbsp;итогам года в&nbsp;отрицательной зоне,
                  геополитическая напряженность, торговые войны, санкционный
                  фактор&nbsp;&mdash; все это не&nbsp;способствует оптимизму
                  среди инвесторов. Кроме этого, год-полтора назад активный
                  интерес клиентов к&nbsp;инвестициям подогревался низкими
                  ставками по&nbsp;депозитам, сейчас время дешевых денег
                  закончилось, ставки растут и&nbsp;инвесторы пересматривают
                  свое отношение к&nbsp;рискам.
                </Paragraph>

                <Paragraph>
                  Тем не&nbsp;менее, мы&nbsp;наблюдаем положительную динамику:
                  еще пару лет назад инвестиционными продуктами пользовалось
                  около 10% клиентов, сегодня&nbsp;&mdash; почти 40%,
                  и&nbsp;их&nbsp;число продолжает расти. Наш инвестиционный
                  портфель вырос за&nbsp;это время в&nbsp;два с&nbsp;половиной
                  раза.
                </Paragraph>
                <Paragraph>
                  <img src="images/media/mileeva_inner21.jpg" width="100%" />
                </Paragraph>
                <Paragraph>
                  Сейчас мы видим повышенный интерес к инвестициям как к способу
                  диверсификации портфеля: для клиентов это возможность снизить
                  страновые риски и риски отдельного банка, а формирование
                  портфеля из облигаций или акций глобальных эмитентов позволяет
                  решить эту задачу. Отмечу важную тенденцию: клиенты хотят
                  более активно участвовать в принятии решений, поэтому в
                  качестве перспективного варианта мы видим работу в формате
                  advisory. Мы запустили эту модель взаимодействия с клиентами в
                  текущем году, и она доказала свою эффективность: у нас нет
                  задачи любой ценой удерживать клиента в инвестиционных
                  инструментах, мы смотрим на совокупный портфель клиента и
                  работаем с ним в динамике. Если на рынке не самое удачное
                  время, мы можем предложить клиенту переложиться, например, из
                  рублевых облигаций и переждать пару месяцев, разместив активы
                  на накопительном счете. {' '}
                  <Accentuation>
                       На наш взгляд, это самый честный
                  подход, единственно правильный, когда ты хочешь быть для
                  клиента, его семьи и бизнеса любимым и надежным партнером на
                  всю жизнь.
                  </Accentuation>

                </Paragraph>
                <Paragraph>
                  <b>
                    Какие технологии внедряете при работе с владельцами крупного
                    частного капитала?
                  </b>
                </Paragraph>
                <Paragraph>
                  Хотим мы&nbsp;этого или нет, но&nbsp;полмира уже сейчас живет
                  в&nbsp;онлайн-пространстве. И&nbsp;Альфа-Банк
                  как технологически передовой банк постоянно предлагает
                  клиентам инновационные цифровые решения.
                </Paragraph>

                <Fact source="Катерина Милеева">
                  На Западе уровень сервиса для клиентов с активами
                  <br />
                  <span
                    style={{
                      fontSize: '40px',
                      paddingTop: '12px',
                      display: 'inline-block',
                      'line-height': '34px',
                    }}
                  >
                    от $100 млн и до $10 млн
                  </span>
                  значительно отличаются
                </Fact>
                <Paragraph>
                  В&nbsp;первую очередь мы&nbsp;фокусируемся на&nbsp;развитии
                  мобильного приложения. В&nbsp;частности&nbsp;&mdash; планируем
                  добавить возможность принятия инвестиционных решений прямо
                  в&nbsp;приложении, интегрируем часть услуг Lifestyle
                  Management.
                </Paragraph>

                <Paragraph>
                  В&nbsp;этом году наша фокус-группа начала тестировать
                  технологию виртуальной реальности. Чтобы получить консультацию
                  финансового или инвестиционного советника, им&nbsp;теперь
                  не&nbsp;нужно выходить из&nbsp;дома&nbsp;&mdash; достаточно
                  надеть VR-гарнитуру и&nbsp;подключиться к&nbsp;виртуальной
                  переговорной. Оказалось, что для многих общаться
                  с&nbsp;3D-аватаром советника проще и&nbsp;удобнее, чем,
                  например, переписываться по&nbsp;Whatsapp, Viber или Skype.
                  В&nbsp;виртуальном пространстве можно интерактивно работать
                  с&nbsp;реальными цифрами, визуализировать их&nbsp;в&nbsp;виде
                  графиков и&nbsp;выполнять многие другие операции
                  &laquo;мановением руки&raquo;.
                </Paragraph>
              </ArticleSpreader>
              <Paragraph>
                <LeftBanner image="images/banners/black-banner.jpg">
                  Мы не ограничиваем возможности клиента ценой и нашей оценкой
                  риска того или иного решения
                </LeftBanner>
              </Paragraph>

              <ArticleSpreader>
                <Paragraph>
                  Мы&nbsp;активно внедряем технологии биометрической
                  идентификации. Например, в&nbsp;Денежном переулке заработал
                  биометрический депозитарий. Как и&nbsp;должно быть
                  в&nbsp;Private Banking, мы&nbsp;используем самую передовую,
                  самую защищенную технологию биометрии&nbsp;&mdash;
                  по&nbsp;рисунку вен ладони. Из&nbsp;российских банков это пока
                  есть только у&nbsp;нас.
                </Paragraph>
                <Paragraph>
                  <b>Есть задачи, которые вы не можете решить?</b>
                </Paragraph>

                <Paragraph>
                  Наш внутренний девиз&nbsp;&mdash; у&nbsp;нас всегда есть
                  решение. Мы&nbsp;не&nbsp;ограничиваем возможности клиента
                  ценой и&nbsp;нашей оценкой риска того или иного решения. Наша
                  задача&nbsp;&mdash; найти и&nbsp;проанализировать оптимальное
                  множество вариантов решения задачи, а&nbsp;выбор
                  за&nbsp;клиентом.{' '}
                  <Accentuation>
                     Хочет он&nbsp;отправить самолетом свои
                    личные ценности в&nbsp;небольшой населенный пункт под
                    Красноярском или осуществить расчеты по&nbsp;сделке
                    купли-продажи актива в&nbsp;весьма редкой валюте&nbsp;&mdash;
                    мы&nbsp;готовим ответ, как это сделать.
                  </Accentuation>{' '}
                  Если решение задачи
                  будет явно слишком дорогим, мы&nbsp;уточним, готов&nbsp;ли
                  клиент к&nbsp;таким расходам. Из&nbsp;решения таких
                  экзотических запросов получаются интересные сделки,
                  а&nbsp;иногда из&nbsp;них даже вырастают регулярные продукты
                  для остальных клиентов.
                </Paragraph>
                <Paragraph>
                  Если в&nbsp;периметре нашей бизнес-модели нет нужной клиенту
                  услуги, мы&nbsp;честно говорим об&nbsp;этом,
                  но&nbsp;и&nbsp;тут предлагаем решение: связываем с&nbsp;нужным
                  экспертом или организацией. А&nbsp;перед этим проведем
                  небольшой due diligence контрагента&nbsp;&mdash; свяжемся
                  и&nbsp;узнаем условия, убедимся в&nbsp;качестве
                  предоставляемой услуги. Вот это и&nbsp;есть работа
                  профессионалов, какой мы&nbsp;ее&nbsp;видим и&nbsp;понимаем
                  в&nbsp;Альфа Private.
                </Paragraph>

                <EndSpreader />
                <MoreArticles
                  articles={[
                    {
                      title: 'Private Banking - от финансов до стиля жизни',
                      url: '/overview',
                      background: 'images/media/anons1.jpg',
                    },
                    {
                      title: 'Цифровые капиталы',
                      url: '/digital',
                      background: 'images/media/anons211.jpg',
                    },
                    {
                      title: 'Забота о благосостоянии',
                      url: '/invest',
                      background: 'images/media/zahod31-1.jpg',
                    },
                  ]}
                />
              </ArticleSpreader>
            </div>
          ),
        },
      ]}
    </Article>
  </div>
);

export default InterviewPage;
